<template>
  <div class="tab-content">
    <div class="main-header">
        <div>
            <h1>{{ $t('controlCenter.sidebar.permissionManagement') }}</h1>
            <p class="subtitle">{{ $t('controlCenter.permissionManagement.subtitle') }}</p>
        </div>
    </div>
    <div class="card">
      <div class="card-body">
        <p>{{ $t('controlCenter.permissionManagement.comingSoon') }}</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PermissionManagement'
};
</script> 